import React, { Component } from 'react';
import { Image } from '..';
import './StorySquarePair.scss';

class StorySquarePair extends Component {
  render() {
    const { input } = this.props;
    const { primary } = input;
    const {
      leftPhoto,
      rightPhoto,
    } = primary;
    return (
      <div className="story-square-pair">
        <div className="container">
          <div className="col col-left">
            <div className="square-photo-container">
              <Image image={leftPhoto} />
            </div>
          </div>
          <div className="col col-right">
            <div className="square-photo-container">
              <Image image={rightPhoto} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default StorySquarePair;
